import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs, useSitemap } from 'wsm-common-data';

import { getModelLink } from '../../utils/getModelLink';

import Slider from '../Slider';
import CarouselCard from '../cards/Carousel';

const CarouselContainer = ({ vehicles }) => {
	const prefs = usePrefs();
	const sitemap = useSitemap();

	const { modelLinkAlias, modelLinkParameters } = prefs;

	return (
		<Slider sliderContentClassnames="vehicles-carousel d-flex mx-10 pb-5 text-center">
			{React.Children.toArray(
				vehicles.map((vehicle) => (
					<CarouselCard
						modelObject={vehicle}
						modelLink={getModelLink(
							`${sitemap.get(modelLinkAlias)}`,
							modelLinkParameters,
							vehicle
						)}
					/>
				))
			)}
		</Slider>
	);
};

export default CarouselContainer;

CarouselContainer.propTypes = {
	vehicles: PropTypes.arrayOf(
		PropTypes.shape({
			year: PropTypes.number,
			make: PropTypes.string,
			model: PropTypes.string,
			gvBodyStyle: PropTypes.string,
			image: PropTypes.string,
			inventoryCount: PropTypes.number
		})
	).isRequired
};
